import React from 'react';
import './excel-upload-error-summary.css';
import { Divider } from 'rsuite';

const ExcelUploadErrorSummary = ({ isFromProd, isVisible, onClose, data }) => {
    if (!isVisible) return null;

    const {
        totalRecords = 0,
        successfulOnboardings = 0,
        failedOnboardings = 0,
        errorRecords = [],
    } = data || {};

    return (
        <div className="error-summary-overlay">
            <div className="error-summary-container">
                <div className="error-summary-header">
                    <div className="error-summary-info">
                        <span><b>Total records:</b> {totalRecords}</span>
                        <span className="success">Successful records: {successfulOnboardings}</span>
                        <span className="failed">Failed records: {failedOnboardings}</span>
                    </div>
                </div>



                <div className="error-table-container">
                    <table className="error-table">
                        <thead>
                            <tr>
                                <th>Row No.</th>
                                <th>Error Description</th>
                            </tr>
                        </thead>
                    </table>
                    <div className="error-table-body-scroll">
                        <table className="error-table">
                            {/* {isFromProd === true && <tbody>
                                {errorRecords.map((item, index) => (
                                    <tr key={index}>
                                        <td>{item.row}</td>
                                        <td>{item.error}</td>
                                    </tr>

                                ))}
                            </tbody>} */}

                            <tbody>
                                {errorRecords.map((item, index) => (
                                    <tr key={index}>
                                        <td>{item.rowNumber.toString().padStart(2, '0')}</td>
                                        <td>{item.errorDetails}</td>
                                    </tr>

                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>


                <div className="error-summary-footer pt-2">
                    <button type='button' className='next-button' onClick={onClose} >
                        Back to Home
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ExcelUploadErrorSummary;
